import declare from "dojo/_base/declare";
import DataSheetItemsPasteForm from "src/SiteAdmin/DataSheet/Paste/DataSheetItemsPasteForm";

const NutrientItemsPasteForm = declare(DataSheetItemsPasteForm, {
	_configNodeType: "FoodLabelNutrientItemsImportConfiguration",
	_configViewId: "FoodLabelNutrientItemsImportConfigurations",
	_lineItemNodeType: "NutrientItem",
});

export = NutrientItemsPasteForm;